<template>
  <div class="uk-flex uk-flex-right">
    <label
      v-if="citations.length && isOpen"
      style="color: gray"
      class="uk-flex uk-flex-column uk-width-1-1 uk-text-small annotation-cite uk-background-muted"
    >
      <span class="labal-cite">Citations:</span>

      <CitationRow
        v-for="citation in citations"
        :key="citation._id"
        :citation="citation"
        :parent="parent"
        :parentCounterpoint="parentCounterpoint"
        :parentAuthor="parentAuthor"
      />

      <span
        v-if="canAddCitation"
        @click="onAddCitation"
        style="width: 26px"
        uk-tooltip="Click to add citation"
        class="uk-margin-small uk-margin-remove-bottom"
      >
        <img
          :src="`/icons/black/icon-black-create-citation.svg`"
          width="28"
          class="citation-icon cite-add-icon"
          style="z-index: 9; opacity: 0.5"
        />
      </span>
    </label>

    <button
      v-if="showSaveButton"
      :disabled="!isValid"
      :uk-tooltip="'Save your changes'"
      class="uk-border-rounded uk-button-primary edit-btn-approve"
      style="height: 25px"
      uk-icon="check"
      @click="onSave"
    ></button>
  </div>
</template>

<script setup lang="ts">
import CitationRow from '@/components/citations/CitationRow.vue';
import type { Citation, Annotation, Counterpoint, Author } from '../types/annotation.types';

// Props
interface Props {
  citations: Citation[];
  isOpen?: boolean;
  canAddCitation?: boolean;
  showSaveButton?: boolean;
  isValid?: boolean;
  parent: Annotation;
  parentCounterpoint: Counterpoint;
  parentAuthor: Author;
}

const _props = withDefaults(defineProps<Props>(), {
  isOpen: false,
  canAddCitation: false,
  showSaveButton: false,
  isValid: true,
});

// Emits
const emit = defineEmits(['addCitation', 'save']);

// Methods
const onAddCitation = () => emit('addCitation');
const onSave = () => emit('save');
</script>

<style scoped lang="scss">
.annotation-cite {
  border: 1px solid black;
  border-radius: 4px;
  margin-top: 5px;
}

.labal-cite {
  color: black;
  padding: 5px 0 0 5px;
}

.cite-add-icon {
  padding: 0 0 4px 4px;
}

.edit-btn-approve {
  padding: 2px 6px;
  margin-right: 7px;
}
</style>
